// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6795907f","513":"7c2ebd21"}[chunkId] + ".chunk.js";
};